// @flow strict
import type {CustomFormField} from 'src/types/crm';

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {
  RadioGroup,
  RadioButton,
} from '@spaced-out/ui-design-system/lib/components/RadioButton';
import classify from 'src/utils/classify';
import css from './index.css';


type FormikFieldType = {
  value: string | boolean,
  name: string,
};

type BooleanRadioGroupProps = {
  field: CustomFormField,
  formikField: FormikFieldType,
  onChange: (field: string, value: string | boolean) => void,
  isRequired: boolean,
  error: ?string,
  touched: boolean,
  label: string,
  classNames?: string,
};

export const BooleanRadioGroup = ({
  field,
  formikField,
  isRequired,
  onChange,
  label,
  error,
  touched,
  classNames,
}: BooleanRadioGroupProps): React.Node => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const hasError = Boolean(error && touched);
  const stringValue =
    typeof formikField.value === 'boolean'
      ? formikField.value
        ? 'Yes'
        : 'No'
      : String(formikField.value || '');

  return (
    <div
      {...formikField}
      className={classify(css.booleanInputContainer, classNames)}
    >
      {label && (
        <label className={css.label}>
          {label}
          {isRequired && <span className={css.required}>*</span>}
        </label>
      )}

      <RadioGroup
        align="horizontal-fluid"
        name={`custom_${field.customFieldId}`}
        value={stringValue}
        onChange={(value) => onChange(formikField.name, value)}
        error={hasError}
        errorText={error || ''}
      >
        <RadioButton value="Yes">{t('Yes', 'Yes')}</RadioButton>

        <RadioButton value="No">{t('No', 'No')}</RadioButton>
      </RadioGroup>
    </div>
  );
};
